// src/views/Signup.js

import React from 'react';
import { withRouter } from 'react-router-dom';
import SignupForm from '../components/sections/SignupForm';
import { TokenService } from '../api/tokenService';

class Signup extends React.Component {
  componentDidMount() {
    const token = TokenService.getLocalAccessToken
      ? TokenService.getLocalAccessToken()
      : localStorage.getItem('accessToken');

    if (token) {
      this.props.history.replace('/'); // already logged in -> redirect home
    }
  }

  render() {
    // 👉 pass history into SignupForm so closeTrialPopup can navigate
    return (
      <SignupForm
        className="illustration-section-01"
        history={this.props.history}
        location={this.props.location}
      />
    );
  }
}

export default withRouter(Signup);
